import React from 'react';
import { Container } from 'react-bootstrap';
import ChatSelector from 'v2/Chat/ChatSelector';
import styles from './discussions.module.scss';

const Discussions = () => {
  return (
    <div>
      <div className="d-flex justify-content-between bg-light position-relative z-index-1 page-title">
        <Container
          className="d-flex justify-content-between position-relative fix-bg-images"
          fluid="xl"
        >
          <div className="d-flex align-items-center text-truncate">
            <h1 className="m-0 text-truncate pr-1">Discussions</h1>
          </div>
        </Container>
      </div>
      <ChatSelector className={styles.chat} />
    </div>
  );
};

export default Discussions;
